/**
 * @ignore
 * @USAGE - calculates the width (in rem) needed to display a string of text according to a particular font-size and font...
 *         uses canvas and doesn't render into the DOM
 * @property {string}   text           Text string to be measured
 * @property {string}   font           Font size to measure against (font property uses the same syntax as the CSS font property) defaults to "0.875rem Nokia Pure"
 */

const ONE_REM = 0.0625;
const getTextWidth = (text, font = '0.875rem Nokia Pure') => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = font;

  // adding 8px to the width to avoid possible miscalculation or pixel fractions.
  const widthPixels = Math.ceil(context.measureText(text).width);
  // convert to rem
  const width = widthPixels * ONE_REM;

  return width;
};

export { getTextWidth as default };